module.exports = __webpack_public_path__ + "static/media/flower_hero_desktop.9c73aedb.jpg";